import React, { useContext, useEffect, useState } from "react";
import Header from "../../../Components/Header/Header";
import Tabs from "../../../Components/Settings/Tabs";
import TabPane from "../../../Components/Settings/TabPane";
import InfoSettings from "../../../Components/Settings/InfoSetting";
import EmailAndNotifications from "../../../Components/Settings/EmailNotifications";
import DeliveryCharge from "../../../Components/Settings/DeliveryCharge";
import RolloverTime from "../../../Components/Settings/RolloverTime";
import UpchargeDates from "../../../Components/Settings/UpchargeDates";
import ZipcodeSettings from "../../../Components/Settings/ZipcodeSettings";
import { AppContext } from "../../../Context/AppContext";
import { MODULES } from "../../../Helpers/Constants";
import { getAccessByModuleName } from "../../../Routes/Routes";

const StoreSetting = (props) => {
	const { modules } = useContext(AppContext);
	const [newStoreAccess, setNewStoreAccess] = useState({});

	useEffect(getModuleAccess, [modules]);

	function getModuleAccess() {
		let newStoreAccess = getAccessByModuleName(modules, MODULES.CONFIG_STORE_SETTING);
		if (newStoreAccess) setNewStoreAccess(newStoreAccess.permissions);
	}

	const handleManageHeaderClick = async (event, link) => {
		event.preventDefault();	
		window.location = link;
	};

	return (
		<React.Fragment>
		<Header 
			title="Store Setting"
			hasAddButton={newStoreAccess.write_access}
        	handleAddClick={(e) =>
				handleManageHeaderClick(
				  e,
				  `/settings/new-store/`
				)
			}
		/>
		<Tabs  >
			<TabPane name="Info" key="1"   >
				<InfoSettings module="edit-store" />
			</TabPane>
			<TabPane name="Email/Notifications (Global)" key="2">
				<EmailAndNotifications />
			</TabPane>
			<TabPane name="Rollover Time" key="3">
				<RolloverTime />
			</TabPane>
			<TabPane name="Upcharge Dates" key="4">
				<UpchargeDates />
			</TabPane>
			<TabPane name="Zipcode Settings" key="5">
				<ZipcodeSettings />
			</TabPane>
			<TabPane name="Delivery Charge (Global)" key="6">
				<DeliveryCharge />
			</TabPane>
		</Tabs>
		</React.Fragment>
	);
};
export default React.memo(StoreSetting);
